<div id="login">
<ul>
  <li *ngIf="currentUser !== null" class="welcome">{{ currentUser.username }}</li>
  <li *ngIf="currentUser !== null && currentUser.isAdmin"><a href="/admin">Admin</a></li>
  <li *ngIf="currentUser !== null"><a href="/profile">Profile</a></li>
  <li *ngIf="currentUser === null"><a href="/login">Login</a></li>
  <li *ngIf="currentUser !== null" (click)="logoutClick()" class="logout">Logout</li>
</ul>
</div>
